export default __webpack_public_path__ + "static/media/2018-observatorio_legislativo_parlamentoedomex.9775cb86.png";